import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Moon } from 'lucide-react';
import { Button } from './Button';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Services',
    path: '/services'
  }, {
    name: 'Pricing',
    path: '/pricing'
  }, {
    name: 'Astrology',
    path: '/astrology'
  }, {
    name: 'Blog',
    path: '/blog'
  }];
  return <header className={`sticky top-0 z-40 transition-all duration-500 ${isScrolled ? 'bg-midnight/80 backdrop-blur-xl border-b border-white/5 py-4 shadow-2xl' : 'bg-transparent py-6'}`} data-id="element-136">
      <div className="container mx-auto px-6 flex items-center justify-between" data-id="element-137">
        <Link to="/" className="flex items-center gap-3 group" data-id="element-138">
          <div className="relative" data-id="element-139">
            <div className="absolute inset-0 bg-gold blur-md opacity-0 group-hover:opacity-50 transition-opacity" data-id="element-140"></div>
            <Moon className="w-7 h-7 text-gold relative z-10" data-id="element-141" />
          </div>
          <div className="flex flex-col" data-id="element-142">
            <span className="font-serif text-2xl font-medium text-white tracking-wide leading-none" data-id="element-143">
              Calmoras
            </span>
            <span className="text-[9px] uppercase tracking-[0.2em] text-gold mt-1" data-id="element-144">
              Healing Sanctuary
            </span>
          </div>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-145">
          {navLinks.map(link => {
          const isActive = location.pathname === link.path || link.path !== '/' && location.pathname.startsWith(link.path);
          return <Link key={link.name} to={link.path} className="relative text-sm font-medium text-beige hover:text-white transition-colors group py-2" data-id="element-146">
                {link.name}
                <span className={`absolute bottom-0 left-0 h-[2px] bg-gold transition-all duration-300 ${isActive ? 'w-full' : 'w-0 group-hover:w-full'}`} data-id="element-147"></span>
              </Link>;
        })}
        </nav>

        <div className="hidden lg:flex items-center gap-4" data-id="element-148">
          <Link to="/login" className="text-sm font-medium text-beige hover:text-gold transition-colors" data-id="element-149">
            Login
          </Link>
          <Button href="/booking" size="sm" variant="primary" data-id="element-150">
            Book Session
          </Button>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden text-white p-2 focus:outline-none" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-151">
          {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-152" /> : <Menu className="w-6 h-6" data-id="element-153" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-154">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: '100vh'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="absolute top-full left-0 right-0 bg-midnight/95 backdrop-blur-3xl border-t border-white/5 lg:hidden overflow-y-auto" data-id="element-155">
            <nav className="flex flex-col p-8 gap-6 min-h-[calc(100vh-80px)]" data-id="element-156">
              {navLinks.map((link, i) => <motion.div key={link.name} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: i * 0.1
          }} data-id="element-157">
                  <Link to={link.path} className="text-3xl font-serif text-white hover:text-gold transition-colors block" data-id="element-158">
                    {link.name}
                  </Link>
                </motion.div>)}

              <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.6
          }} className="mt-auto pt-8 border-t border-white/10 space-y-4" data-id="element-159">
                <Link to="/login" className="text-lg text-beige hover:text-gold transition-colors block mb-4" data-id="element-160">
                  Login to Account
                </Link>
                <Button href="/booking" fullWidth variant="primary" size="lg" data-id="element-161">
                  Book Session
                </Button>
              </motion.div>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}